module.exports = __webpack_public_path__ + "img/5.43f5a3e2.png";